// Providers shared by the app and the tests: TanStack Query · i18next · app-wide layers (toasts, tooltip, live region).
// The router (and the dialogs, which may contain links) sit inside.
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { i18n as I18n } from 'i18next';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { UiLayers } from './ui/layers';

export function AppProviders({ queryClient, i18n, children }: { queryClient: QueryClient; i18n: I18n; children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <UiLayers>{children}</UiLayers>
      </I18nextProvider>
    </QueryClientProvider>
  );
}
